export default __webpack_public_path__ + "static/aviasales-1ad11ea775b31348f396e8aac003486b.png";